
export { apiInstance } from "/home/runner/work/mangomap/mangomap/packages/utils/src/axios/index.ts"